import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import { uploadToCloudinary } from "../../../helpers/upload";

const DynamicFormModal = ({
    show,
    onHide,
    title,
    fields = [],
    initialData = {},
    dropdownData = {},
    uploadOptions,
    onSubmit
}) => {
    const [formData, setFormData] = useState({});
    const [fileMap, setFileMap] = useState({});
    const [uploading, setUploading] = useState(false);

    useEffect(() => {
        setFormData(initialData);
    }, [initialData]);

    const getFieldValue = (name) => {
        if (name.includes(".")) {
            const [parent, child] = name.split(".");
            return formData[parent]?.[child] || "";
        }

        return formData[name] || "";
    };

    const handleChange = async (name, value) => {

        // Handle nested properties like "properties.color"
        if (name.includes(".")) {
            const [parent, child] = name.split(".");

            setFormData(prev => ({
                ...prev,
                [parent]: {
                    ...prev[parent],
                    [child]: value
                }
            }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }

        const field = fields.find(f => f.name === name);

        if (field?.onChange) {
            await field.onChange(value, { formData, setFormData });
        }
    };

    const handleFileChange = (name, file) => {
        setFileMap(prev => ({ ...prev, [name]: file }));
    };

    const uploadFilesIfNeeded = async () => {
        let updatedData = { ...formData };

        for (const field of fields) {
            if (field.type === "file" && fileMap[field.name]) {
                setUploading(true);

                const dynamicOptions = {
                    ...uploadOptions,
                    slug: formData.name, // 👈 automatic
                };

                const res = await uploadToCloudinary(
                    fileMap[field.name],
                    dynamicOptions
                );

                updatedData[field.name] = {
                    url: res.secure_url,
                    public_id: res.public_id
                };
            }
        }

        setUploading(false);
        return updatedData;
    };



    const handleSubmit = async () => {
        try {
            console.log("Fields: ", fields);
            console.log("Form DAta: ", formData);
            for (const field of fields) {
                if (field.name.includes(".")) {
                    const [parent, child] = field.name.split(".");
                    if (field.required && !formData[parent][child]) {
                        toast.error(`${field.label} is required`);
                        return;
                    }
                } else {
                    if (field.required && !formData[field.name] && !fileMap[field.name]) {
                        toast.error(`${field.label} is required`);
                        return;
                    }
                }
            }

            const finalData = await uploadFilesIfNeeded();
            onSubmit(finalData);
            onHide();
        } catch (err) {
            toast.error("Something went wrong");
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title style={{ fontSize: 16 }}>{title}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {fields.map(field => (
                    <div className="mb-3" key={field.name}>
                        <label className="form-label">{field.label}</label>

                        {(field.type === "text" || field.type === "number") && (
                            <input
                                type="text"
                                className="form-control"
                                value={getFieldValue(field.name)}
                                onChange={e => handleChange(field.name, e.target.value)}
                            />
                        )}

                        {field.type === "file" && (
                            <input
                                type="file"
                                className="form-control"
                                accept="image/*"
                                onChange={e =>
                                    handleFileChange(field.name, e.target.files[0])
                                }
                            />
                        )}

                        {field.type === "select" && (
                            <select
                                className="form-select"
                                value={getFieldValue(field.name)}
                                onChange={e => handleChange(field.name, e.target.value)}
                            >
                                <option value="">Select {field.label}</option>
                                {
                                    dropdownData[field.optionsKey]?.map((opt, i) => {
                                        return (
                                            <option key={i} value={opt?._id}>
                                                {opt?.name}
                                            </option>
                                        )
                                    })
                                }
                            </select>
                        )}
                    </div>
                ))}

                <button
                    className="btn btn-primary"
                    disabled={uploading}
                    onClick={handleSubmit}
                >
                    Save
                </button>
            </Modal.Body>
        </Modal>
    );
};

export default DynamicFormModal;
